import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { change, submit, isSubmitting } from "redux-form";
import { UPDATE } from "react-admin";
import { showNotification, Button, SaveButton, SimpleForm } from "react-admin";
import IconCancel from "@material-ui/icons/Cancel";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Cancel from "@material-ui/icons/Cancel";
import dataProviderFactory from "../dataProvider";
import ListBikeHistory from "./listBikeHistory";
import TextField from "@material-ui/core/TextField";
import moment from "moment";
import ButtonWithConfirmation from "../components/ButtonWithConfirmation";
import classnames from 'classnames';
import SaveIcon from '@material-ui/icons/Save';
import { fade } from '@material-ui/core/styles/colorManipulator';
import { getPermissionRole } from "../util";

class QuickRetireButton extends Component {
  handleDateChange = element => {
    this.setState({ date: element.target.value });
  };

  state = {
    error: false,
    showDialog: false,
    retirementDate: Date.now(),
    date: moment(Date.parse(Date.now())).format("YYYY-MM-DD"),
    stateConfirmation: false,
    stateRetire: true
  };

  SetDate = (param) => {
    this.setState({
      date: moment(Date.parse(param)).format("YYYY-MM-DD")
    })
  }

  handleClick = () => {
    this.setState({ showDialog: true });
  };

  handleCloseClick = () => {
    this.setState({ showDialog: false });
    this.props.callBack();
  };

  handleConfirmationClick = () => {
    this.setState({ stateRetire: false,  stateConfirmation: true});
    this.props.callBack();
  };

  handleConfirmationCancelClick = () => {
    this.setState({ stateRetire: true,  stateConfirmation: false});
    this.props.callBack();
  };

  handleSaveClick = () => {
    //this.props.vehicle.sale_date = this.state.date
    //console.log(this.props.vehicle.sale_date)
    const { submit } = this.props;
    submit("retire-bike-update");
  };

  handleSubmit = async () => {
    const bodyRequest = {
      id: this.props.vehicle.id,
      data: { status: "V", date: this.state.date }
    };
    const dataProvider = await dataProviderFactory("rest");
    dataProvider(UPDATE, "vehicles", bodyRequest)
      .then(() => {
        this.setState({ showDialog: false });
        this.props.callBack();
      })
      .catch(error => {
        showNotification(error.message, "error");
      });
  };

  isRenting = (purchase_date, diferenciaMeses) => {
    return (
      <Fragment>
      <br />
      <span>Purchase date: {moment(purchase_date).format("DD-MM-YYYY")} </span>
      <br />
      <span> Months past from the purchase date: {diferenciaMeses} </span> 
      </Fragment>
    )  
  }

  render() {
    const { showDialog, stateRetire } = this.state;
    const { isSubmitting } = this.props;
    const { label = 'ra.action.delete', classes = {}, className } = this.props;

    const fecha1 = moment(this.props.vehicle.purchase_date)
    const fecha2 = moment(this.state.date)
    let diferenciaMeses = fecha2.diff(fecha1, 'months')
    
    return ( 
      <Fragment>
        <Fragment>
        <Cancel
          titleAccess="Retire bike (put for sale)"
          onClick={this.handleClick}
          cursor="pointer"
        />
        <Dialog
          fullWidth={true}
          maxWidth={"md"}
          open={showDialog}
          onClose={this.handleCloseClick}
          aria-label="Retire bike"
        >
          <DialogTitle>Retire bike</DialogTitle>
          <DialogContent>
            <div hidden={!this.state.stateRetire}>
              <span>
                Do you want to put the bike{" "}
                <b>
                  ({this.props.vehicle.model.model_name} -{" "}
                  {this.props.vehicle.licence_plate} {this.props.vehicle.renting ? "®" : ""})
                </b>{" "}
                {this.props.vehicle.renting ? "in retirement?" : 'up for sale?'}{" "}
              </span>{" "}
              <br />
              <ListBikeHistory SetDate={this.SetDate} vehicleId={this.props.vehicle.id} />
            </div> 
            <div hidden={!this.state.stateConfirmation}>  
                <div>Are you sure you want to perform this action?</div>
                <div>
                  <div>
                    Your answer will be recorded.
                  </div>
                </div>
            </div>
            <SimpleForm
              form="retire-bike-update"
              resource="vehicles"
              onSubmit={this.handleSubmit}
              toolbar={null}
            >
              <TextField
                id="retirement_date"
                label="Retirement date"
                type="date"
                onChange={this.handleDateChange}
                value={this.state.date}
                hidden
                InputLabelProps={{
                  shrink: true
                }}
              />
              {this.props.vehicle.renting ?  this.isRenting(fecha1, diferenciaMeses) : ''  }
              {/* <input id="retirement_date" label="Retirement date"
                type="date"
                min={this.state.date}
                onChange={this.handleDateChange}
                value={this.state.date} ></input> */}
            </SimpleForm>
          </DialogContent>
          <DialogActions> 
            <div hidden={!this.state.stateConfirmation}>
            {([1, 2, 6, 9].includes(getPermissionRole()) && 
              <SaveButton saving={isSubmitting} onClick={this.handleSaveClick} />
            )}
            </div>
            <div hidden={!this.state.stateRetire}>
            {([1, 2, 6, 9].includes(getPermissionRole()) &&
              <SaveButton label="Confirm to save" onClick={this.handleConfirmationClick}>
                <SaveIcon />
              </SaveButton> 
            )}
            </div> 
            <div hidden={!this.state.stateConfirmation}>
              <Button label="ra.action.cancel" onClick={this.handleConfirmationCancelClick}>
                <IconCancel />
              </Button>
            </div> 
            <div hidden={!this.state.stateRetire}> 
              <Button label="ra.action.cancel" onClick={this.handleCloseClick}>
                <IconCancel />
              </Button>
            </div> 
            
          </DialogActions>
        </Dialog>
        </Fragment> 
      </Fragment> 
    );
  }
}

const mapStateToProps = state => ({
  isSubmitting: isSubmitting("retire-bike-update")(state)
});

const mapDispatchToProps = {
  change,
  showNotification,
  submit
};

export default connect(mapStateToProps, mapDispatchToProps)(QuickRetireButton);



// WEBPACK FOOTER //
// ./src/components/quickRetireButton.js